var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssignmentLate = function SvgAssignmentLate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-280q14 0 24.5-10.5T515-315t-10.5-24.5T480-350t-24.5 10.5T445-315t10.5 24.5T480-280m-31-132h60v-268h-60zM180-120q-24.75 0-42.375-17.625T120-180v-600q0-24.75 17.625-42.375T180-840h205q5-35 32-57.5t63-22.5 63 22.5 32 57.5h205q24.75 0 42.375 17.625T840-780v600q0 24.75-17.625 42.375T780-120zm0-60h600v-600H180zm300-617q14 0 24.5-10.5T515-832t-10.5-24.5T480-867t-24.5 10.5T445-832t10.5 24.5T480-797M180-180v-600z"
  })));
};
export default SvgAssignmentLate;